export type GeneratorCause = {
  cause: string;
  probability: number;
};

export type GeneratorFault = {
  id: string;
  category_id: string | null;
  device_ar: string;
  name_ar: string;
  description_ar: string;
  symptoms: string[];
  causes: GeneratorCause[];
  tests: {
    test: string;
    location: string;
    method: string;
    normal: string;
    faulty: string;
  }[];
  solutions: string[];
  severity: string;
  safety_warnings: string[];
  error_code: string | null;
  keywords: string;
  next_question_key: string | null;
};

type Row = [
  string,
  string,
  string,
  string,
  string,
  GeneratorCause[],
  string[],
  string,
  string
];

const C = (cause: string, probability: number): GeneratorCause => ({
  cause,
  probability,
});

const rows: Row[] = [
[
  "generator-001",
  "بطارية تشغيل المولد",
  "بطارية تشغيل المولد ما يشتغل أو ما ينفذ وظيفته",
  "وظيفة بطارية تشغيل المولد متوقفة أو مو موجودة بالصورة الطبيعية.",
  "توقف وظيفة بطارية تشغيل المولد",
  [C("تغذية أو إشارة مفقودة", 35), C("المكوّن نفسه متضرر", 30), C("توصيل أو حماية مانعة التشغيل", 20), C("تحميل أعلى من قدرة المولد", 15)],
  ["افحص التغذية والحماية والتوصيلات.", "بدل أو صلح الجزء المتضرر بعد العزل."],
  "عالية",
  "المولدات starting battery not working open",
],
[
  "generator-002",
  "بطارية تشغيل المولد",
  "حرارة بطارية تشغيل المولد ترتفع",
  "حرارة بطارية تشغيل المولد أعلى من الطبيعي أثناء التشغيل.",
  "ارتفاع حرارة بطارية تشغيل المولد",
  [C("تحميل أعلى من التصميم", 35), C("ربط مقاومته عالية", 30), C("تهوية أو تبريد غير كافي", 20), C("تحميل أعلى من قدرة المولد", 15)],
  ["خفف الحمل إذا ممكن وافحص التبريد.", "اعزل المعدة إذا الحرارة أو ريحة الحرك قوية."],
  "حرجة",
  "المولدات starting battery overheating hot",
],
[
  "generator-003",
  "بطارية تشغيل المولد",
  "بطارية تشغيل المولد يشتغل أو يقرا بصورة غير مستقرة",
  "أداء أو قراءة بطارية تشغيل المولد تتغير أو تقطع بدون سبب طبيعي.",
  "تشغيل أو قراءة متقطعة",
  [C("ترمنل أو وصلة مرخية", 35), C("تغذية أو إشارة متذبذبة", 30), C("المكوّن بدأ يتدهور", 20), C("تحميل أعلى من قدرة المولد", 15)],
  ["راقب الحالة وقت ظهور العطل.", "افحص الربطات والتغذية والإشارة المرتبطة بالمكوّن."],
  "عالية",
  "المولدات starting battery intermittent unstable",
],
[
  "generator-004",
  "بطارية تشغيل المولد",
  "بطارية تشغيل المولد بيه ربط أو توصيل مو صحيح",
  "أكو ربط مرخي أو توصيل مو مطابق أو نقطة تلامس ضعيفة مرتبطة بـ بطارية تشغيل المولد.",
  "ربط أو توصيل غير سليم",
  [C("برغي أو ترمنل مرخي", 35), C("توصيل سابق مو مطابق", 30), C("أكسدة أو تلف بنقطة الربط", 20), C("تحميل أعلى من قدرة المولد", 15)],
  ["اعزل التغذية قبل إعادة الربط.", "نظف أو بدل اللگ أو الترمنل المتضرر."],
  "حرجة",
  "المولدات starting battery loose wrong connection",
],
[
  "generator-005",
  "بطارية تشغيل المولد",
  "قراءة أو خرج بطارية تشغيل المولد مو طبيعي",
  "قراءة أو خرج بطارية تشغيل المولد أعلى أو أقل أو مختلف عن المطلوب.",
  "قراءة أو خرج غير طبيعي",
  [C("إعداد أو معايرة غلط", 35), C("مصدر أو حمل مو طبيعي", 30), C("المكوّن أو الحساس المرتبط بيه متضرر", 20), C("تحميل أعلى من قدرة المولد", 15)],
  ["قارن القراءة بالمواصفات أو بقياس مرجعي.", "راجع الإعدادات والمكوّن المرتبط بالقياس."],
  "متوسطة",
  "المولدات starting battery abnormal reading output",
],
[
  "generator-006",
  "Starter Motor",
  "Starter Motor ما يشتغل أو ما ينفذ وظيفته",
  "وظيفة Starter Motor متوقفة أو مو موجودة بالصورة الطبيعية.",
  "توقف وظيفة Starter Motor",
  [C("تغذية أو إشارة مفقودة", 35), C("المكوّن نفسه متضرر", 30), C("توصيل أو حماية مانعة التشغيل", 20), C("تحميل أعلى من قدرة المولد", 15)],
  ["افحص التغذية والحماية والتوصيلات.", "بدل أو صلح الجزء المتضرر بعد العزل."],
  "عالية",
  "المولدات starter motor not working open",
],
[
  "generator-007",
  "Starter Motor",
  "حرارة Starter Motor ترتفع",
  "حرارة Starter Motor أعلى من الطبيعي أثناء التشغيل.",
  "ارتفاع حرارة Starter Motor",
  [C("تحميل أعلى من التصميم", 35), C("ربط مقاومته عالية", 30), C("تهوية أو تبريد غير كافي", 20), C("تحميل أعلى من قدرة المولد", 15)],
  ["خفف الحمل إذا ممكن وافحص التبريد.", "اعزل المعدة إذا الحرارة أو ريحة الحرك قوية."],
  "حرجة",
  "المولدات starter motor overheating hot",
],
[
  "generator-008",
  "Starter Motor",
  "Starter Motor يشتغل أو يقرا بصورة غير مستقرة",
  "أداء أو قراءة Starter Motor تتغير أو تقطع بدون سبب طبيعي.",
  "تشغيل أو قراءة متقطعة",
  [C("ترمنل أو وصلة مرخية", 35), C("تغذية أو إشارة متذبذبة", 30), C("المكوّن بدأ يتدهور", 20), C("تحميل أعلى من قدرة المولد", 15)],
  ["راقب الحالة وقت ظهور العطل.", "افحص الربطات والتغذية والإشارة المرتبطة بالمكوّن."],
  "عالية",
  "المولدات starter motor intermittent unstable",
],
[
  "generator-009",
  "Starter Motor",
  "Starter Motor بيه ربط أو توصيل مو صحيح",
  "أكو ربط مرخي أو توصيل مو مطابق أو نقطة تلامس ضعيفة مرتبطة بـ Starter Motor.",
  "ربط أو توصيل غير سليم",
  [C("برغي أو ترمنل مرخي", 35), C("توصيل سابق مو مطابق", 30), C("أكسدة أو تلف بنقطة الربط", 20), C("تحميل أعلى من قدرة المولد", 15)],
  ["اعزل التغذية قبل إعادة الربط.", "نظف أو بدل اللگ أو الترمنل المتضرر."],
  "حرجة",
  "المولدات starter motor loose wrong connection",
],
[
  "generator-010",
  "Starter Motor",
  "قراءة أو خرج Starter Motor مو طبيعي",
  "قراءة أو خرج Starter Motor أعلى أو أقل أو مختلف عن المطلوب.",
  "قراءة أو خرج غير طبيعي",
  [C("إعداد أو معايرة غلط", 35), C("مصدر أو حمل مو طبيعي", 30), C("المكوّن أو الحساس المرتبط بيه متضرر", 20), C("تحميل أعلى من قدرة المولد", 15)],
  ["قارن القراءة بالمواصفات أو بقياس مرجعي.", "راجع الإعدادات والمكوّن المرتبط بالقياس."],
  "متوسطة",
  "المولدات starter motor abnormal reading output",
],
[
  "generator-011",
  "شاحن البطارية",
  "شاحن البطارية ما يشتغل أو ما ينفذ وظيفته",
  "وظيفة شاحن البطارية متوقفة أو مو موجودة بالصورة الطبيعية.",
  "توقف وظيفة شاحن البطارية",
  [C("تغذية أو إشارة مفقودة", 35), C("المكوّن نفسه متضرر", 30), C("توصيل أو حماية مانعة التشغيل", 20), C("تحميل أعلى من قدرة المولد", 15)],
  ["افحص التغذية والحماية والتوصيلات.", "بدل أو صلح الجزء المتضرر بعد العزل."],
  "عالية",
  "المولدات battery charger not working open",
],
[
  "generator-012",
  "شاحن البطارية",
  "حرارة شاحن البطارية ترتفع",
  "حرارة شاحن البطارية أعلى من الطبيعي أثناء التشغيل.",
  "ارتفاع حرارة شاحن البطارية",
  [C("تحميل أعلى من التصميم", 35), C("ربط مقاومته عالية", 30), C("تهوية أو تبريد غير كافي", 20), C("تحميل أعلى من قدرة المولد", 15)],
  ["خفف الحمل إذا ممكن وافحص التبريد.", "اعزل المعدة إذا الحرارة أو ريحة الحرك قوية."],
  "حرجة",
  "المولدات battery charger overheating hot",
],
[
  "generator-013",
  "شاحن البطارية",
  "شاحن البطارية يشتغل أو يقرا بصورة غير مستقرة",
  "أداء أو قراءة شاحن البطارية تتغير أو تقطع بدون سبب طبيعي.",
  "تشغيل أو قراءة متقطعة",
  [C("ترمنل أو وصلة مرخية", 35), C("تغذية أو إشارة متذبذبة", 30), C("المكوّن بدأ يتدهور", 20), C("تحميل أعلى من قدرة المولد", 15)],
  ["راقب الحالة وقت ظهور العطل.", "افحص الربطات والتغذية والإشارة المرتبطة بالمكوّن."],
  "عالية",
  "المولدات battery charger intermittent unstable",
],
[
  "generator-014",
  "شاحن البطارية",
  "شاحن البطارية بيه ربط أو توصيل مو صحيح",
  "أكو ربط مرخي أو توصيل مو مطابق أو نقطة تلامس ضعيفة مرتبطة بـ شاحن البطارية.",
  "ربط أو توصيل غير سليم",
  [C("برغي أو ترمنل مرخي", 35), C("توصيل سابق مو مطابق", 30), C("أكسدة أو تلف بنقطة الربط", 20), C("تحميل أعلى من قدرة المولد", 15)],
  ["اعزل التغذية قبل إعادة الربط.", "نظف أو بدل اللگ أو الترمنل المتضرر."],
  "حرجة",
  "المولدات battery charger loose wrong connection",
],
[
  "generator-015",
  "شاحن البطارية",
  "قراءة أو خرج شاحن البطارية مو طبيعي",
  "قراءة أو خرج شاحن البطارية أعلى أو أقل أو مختلف عن المطلوب.",
  "قراءة أو خرج غير طبيعي",
  [C("إعداد أو معايرة غلط", 35), C("مصدر أو حمل مو طبيعي", 30), C("المكوّن أو الحساس المرتبط بيه متضرر", 20), C("تحميل أعلى من قدرة المولد", 15)],
  ["قارن القراءة بالمواصفات أو بقياس مرجعي.", "راجع الإعدادات والمكوّن المرتبط بالقياس."],
  "متوسطة",
  "المولدات battery charger abnormal reading output",
],
[
  "generator-016",
  "محرك الديزل",
  "محرك الديزل ما يشتغل أو ما ينفذ وظيفته",
  "وظيفة محرك الديزل متوقفة أو مو موجودة بالصورة الطبيعية.",
  "توقف وظيفة محرك الديزل",
  [C("تغذية أو إشارة مفقودة", 35), C("المكوّن نفسه متضرر", 30), C("توصيل أو حماية مانعة التشغيل", 20), C("تحميل أعلى من قدرة المولد", 15)],
  ["افحص التغذية والحماية والتوصيلات.", "بدل أو صلح الجزء المتضرر بعد العزل."],
  "عالية",
  "المولدات diesel engine not working open",
],
[
  "generator-017",
  "محرك الديزل",
  "حرارة محرك الديزل ترتفع",
  "حرارة محرك الديزل أعلى من الطبيعي أثناء التشغيل.",
  "ارتفاع حرارة محرك الديزل",
  [C("تحميل أعلى من التصميم", 35), C("ربط مقاومته عالية", 30), C("تهوية أو تبريد غير كافي", 20), C("تحميل أعلى من قدرة المولد", 15)],
  ["خفف الحمل إذا ممكن وافحص التبريد.", "اعزل المعدة إذا الحرارة أو ريحة الحرك قوية."],
  "حرجة",
  "المولدات diesel engine overheating hot",
],
[
  "generator-018",
  "محرك الديزل",
  "محرك الديزل يشتغل أو يقرا بصورة غير مستقرة",
  "أداء أو قراءة محرك الديزل تتغير أو تقطع بدون سبب طبيعي.",
  "تشغيل أو قراءة متقطعة",
  [C("ترمنل أو وصلة مرخية", 35), C("تغذية أو إشارة متذبذبة", 30), C("المكوّن بدأ يتدهور", 20), C("تحميل أعلى من قدرة المولد", 15)],
  ["راقب الحالة وقت ظهور العطل.", "افحص الربطات والتغذية والإشارة المرتبطة بالمكوّن."],
  "عالية",
  "المولدات diesel engine intermittent unstable",
],
[
  "generator-019",
  "محرك الديزل",
  "محرك الديزل بيه ربط أو توصيل مو صحيح",
  "أكو ربط مرخي أو توصيل مو مطابق أو نقطة تلامس ضعيفة مرتبطة بـ محرك الديزل.",
  "ربط أو توصيل غير سليم",
  [C("برغي أو ترمنل مرخي", 35), C("توصيل سابق مو مطابق", 30), C("أكسدة أو تلف بنقطة الربط", 20), C("تحميل أعلى من قدرة المولد", 15)],
  ["اعزل التغذية قبل إعادة الربط.", "نظف أو بدل اللگ أو الترمنل المتضرر."],
  "حرجة",
  "المولدات diesel engine loose wrong connection",
],
[
  "generator-020",
  "محرك الديزل",
  "قراءة أو خرج محرك الديزل مو طبيعي",
  "قراءة أو خرج محرك الديزل أعلى أو أقل أو مختلف عن المطلوب.",
  "قراءة أو خرج غير طبيعي",
  [C("إعداد أو معايرة غلط", 35), C("مصدر أو حمل مو طبيعي", 30), C("المكوّن أو الحساس المرتبط بيه متضرر", 20), C("تحميل أعلى من قدرة المولد", 15)],
  ["قارن القراءة بالمواصفات أو بقياس مرجعي.", "راجع الإعدادات والمكوّن المرتبط بالقياس."],
  "متوسطة",
  "المولدات diesel engine abnormal reading output",
],
[
  "generator-021",
  "منظومة الوقود",
  "منظومة الوقود ما يشتغل أو ما ينفذ وظيفته",
  "وظيفة منظومة الوقود متوقفة أو مو موجودة بالصورة الطبيعية.",
  "توقف وظيفة منظومة الوقود",
  [C("تغذية أو إشارة مفقودة", 35), C("المكوّن نفسه متضرر", 30), C("توصيل أو حماية مانعة التشغيل", 20), C("تحميل أعلى من قدرة المولد", 15)],
  ["افحص التغذية والحماية والتوصيلات.", "بدل أو صلح الجزء المتضرر بعد العزل."],
  "عالية",
  "المولدات fuel system not working open",
],
[
  "generator-022",
  "منظومة الوقود",
  "حرارة منظومة الوقود ترتفع",
  "حرارة منظومة الوقود أعلى من الطبيعي أثناء التشغيل.",
  "ارتفاع حرارة منظومة الوقود",
  [C("تحميل أعلى من التصميم", 35), C("ربط مقاومته عالية", 30), C("تهوية أو تبريد غير كافي", 20), C("تحميل أعلى من قدرة المولد", 15)],
  ["خفف الحمل إذا ممكن وافحص التبريد.", "اعزل المعدة إذا الحرارة أو ريحة الحرك قوية."],
  "حرجة",
  "المولدات fuel system overheating hot",
],
[
  "generator-023",
  "منظومة الوقود",
  "منظومة الوقود يشتغل أو يقرا بصورة غير مستقرة",
  "أداء أو قراءة منظومة الوقود تتغير أو تقطع بدون سبب طبيعي.",
  "تشغيل أو قراءة متقطعة",
  [C("ترمنل أو وصلة مرخية", 35), C("تغذية أو إشارة متذبذبة", 30), C("المكوّن بدأ يتدهور", 20), C("تحميل أعلى من قدرة المولد", 15)],
  ["راقب الحالة وقت ظهور العطل.", "افحص الربطات والتغذية والإشارة المرتبطة بالمكوّن."],
  "عالية",
  "المولدات fuel system intermittent unstable",
],
[
  "generator-024",
  "منظومة الوقود",
  "منظومة الوقود بيه ربط أو توصيل مو صحيح",
  "أكو ربط مرخي أو توصيل مو مطابق أو نقطة تلامس ضعيفة مرتبطة بـ منظومة الوقود.",
  "ربط أو توصيل غير سليم",
  [C("برغي أو ترمنل مرخي", 35), C("توصيل سابق مو مطابق", 30), C("أكسدة أو تلف بنقطة الربط", 20), C("تحميل أعلى من قدرة المولد", 15)],
  ["اعزل التغذية قبل إعادة الربط.", "نظف أو بدل اللگ أو الترمنل المتضرر."],
  "حرجة",
  "المولدات fuel system loose wrong connection",
],
[
  "generator-025",
  "منظومة الوقود",
  "قراءة أو خرج منظومة الوقود مو طبيعي",
  "قراءة أو خرج منظومة الوقود أعلى أو أقل أو مختلف عن المطلوب.",
  "قراءة أو خرج غير طبيعي",
  [C("إعداد أو معايرة غلط", 35), C("مصدر أو حمل مو طبيعي", 30), C("المكوّن أو الحساس المرتبط بيه متضرر", 20), C("تحميل أعلى من قدرة المولد", 15)],
  ["قارن القراءة بالمواصفات أو بقياس مرجعي.", "راجع الإعدادات والمكوّن المرتبط بالقياس."],
  "متوسطة",
  "المولدات fuel system abnormal reading output",
],
[
  "generator-026",
  "فلتر الوقود",
  "فلتر الوقود ما يشتغل أو ما ينفذ وظيفته",
  "وظيفة فلتر الوقود متوقفة أو مو موجودة بالصورة الطبيعية.",
  "توقف وظيفة فلتر الوقود",
  [C("تغذية أو إشارة مفقودة", 35), C("المكوّن نفسه متضرر", 30), C("توصيل أو حماية مانعة التشغيل", 20), C("تحميل أعلى من قدرة المولد", 15)],
  ["افحص التغذية والحماية والتوصيلات.", "بدل أو صلح الجزء المتضرر بعد العزل."],
  "عالية",
  "المولدات fuel filter not working open",
],
[
  "generator-027",
  "فلتر الوقود",
  "حرارة فلتر الوقود ترتفع",
  "حرارة فلتر الوقود أعلى من الطبيعي أثناء التشغيل.",
  "ارتفاع حرارة فلتر الوقود",
  [C("تحميل أعلى من التصميم", 35), C("ربط مقاومته عالية", 30), C("تهوية أو تبريد غير كافي", 20), C("تحميل أعلى من قدرة المولد", 15)],
  ["خفف الحمل إذا ممكن وافحص التبريد.", "اعزل المعدة إذا الحرارة أو ريحة الحرك قوية."],
  "حرجة",
  "المولدات fuel filter overheating hot",
],
[
  "generator-028",
  "فلتر الوقود",
  "فلتر الوقود يشتغل أو يقرا بصورة غير مستقرة",
  "أداء أو قراءة فلتر الوقود تتغير أو تقطع بدون سبب طبيعي.",
  "تشغيل أو قراءة متقطعة",
  [C("ترمنل أو وصلة مرخية", 35), C("تغذية أو إشارة متذبذبة", 30), C("المكوّن بدأ يتدهور", 20), C("تحميل أعلى من قدرة المولد", 15)],
  ["راقب الحالة وقت ظهور العطل.", "افحص الربطات والتغذية والإشارة المرتبطة بالمكوّن."],
  "عالية",
  "المولدات fuel filter intermittent unstable",
],
[
  "generator-029",
  "فلتر الوقود",
  "فلتر الوقود بيه ربط أو توصيل مو صحيح",
  "أكو ربط مرخي أو توصيل مو مطابق أو نقطة تلامس ضعيفة مرتبطة بـ فلتر الوقود.",
  "ربط أو توصيل غير سليم",
  [C("برغي أو ترمنل مرخي", 35), C("توصيل سابق مو مطابق", 30), C("أكسدة أو تلف بنقطة الربط", 20), C("تحميل أعلى من قدرة المولد", 15)],
  ["اعزل التغذية قبل إعادة الربط.", "نظف أو بدل اللگ أو الترمنل المتضرر."],
  "حرجة",
  "المولدات fuel filter loose wrong connection",
],
[
  "generator-030",
  "فلتر الوقود",
  "قراءة أو خرج فلتر الوقود مو طبيعي",
  "قراءة أو خرج فلتر الوقود أعلى أو أقل أو مختلف عن المطلوب.",
  "قراءة أو خرج غير طبيعي",
  [C("إعداد أو معايرة غلط", 35), C("مصدر أو حمل مو طبيعي", 30), C("المكوّن أو الحساس المرتبط بيه متضرر", 20), C("تحميل أعلى من قدرة المولد", 15)],
  ["قارن القراءة بالمواصفات أو بقياس مرجعي.", "راجع الإعدادات والمكوّن المرتبط بالقياس."],
  "متوسطة",
  "المولدات fuel filter abnormal reading output",
],
[
  "generator-031",
  "منظومة الزيت",
  "منظومة الزيت ما يشتغل أو ما ينفذ وظيفته",
  "وظيفة منظومة الزيت متوقفة أو مو موجودة بالصورة الطبيعية.",
  "توقف وظيفة منظومة الزيت",
  [C("تغذية أو إشارة مفقودة", 35), C("المكوّن نفسه متضرر", 30), C("توصيل أو حماية مانعة التشغيل", 20), C("تحميل أعلى من قدرة المولد", 15)],
  ["افحص التغذية والحماية والتوصيلات.", "بدل أو صلح الجزء المتضرر بعد العزل."],
  "عالية",
  "المولدات engine oil not working open",
],
[
  "generator-032",
  "منظومة الزيت",
  "حرارة منظومة الزيت ترتفع",
  "حرارة منظومة الزيت أعلى من الطبيعي أثناء التشغيل.",
  "ارتفاع حرارة منظومة الزيت",
  [C("تحميل أعلى من التصميم", 35), C("ربط مقاومته عالية", 30), C("تهوية أو تبريد غير كافي", 20), C("تحميل أعلى من قدرة المولد", 15)],
  ["خفف الحمل إذا ممكن وافحص التبريد.", "اعزل المعدة إذا الحرارة أو ريحة الحرك قوية."],
  "حرجة",
  "المولدات engine oil overheating hot",
],
[
  "generator-033",
  "منظومة الزيت",
  "منظومة الزيت يشتغل أو يقرا بصورة غير مستقرة",
  "أداء أو قراءة منظومة الزيت تتغير أو تقطع بدون سبب طبيعي.",
  "تشغيل أو قراءة متقطعة",
  [C("ترمنل أو وصلة مرخية", 35), C("تغذية أو إشارة متذبذبة", 30), C("المكوّن بدأ يتدهور", 20), C("تحميل أعلى من قدرة المولد", 15)],
  ["راقب الحالة وقت ظهور العطل.", "افحص الربطات والتغذية والإشارة المرتبطة بالمكوّن."],
  "عالية",
  "المولدات engine oil intermittent unstable",
],
[
  "generator-034",
  "منظومة الزيت",
  "منظومة الزيت بيه ربط أو توصيل مو صحيح",
  "أكو ربط مرخي أو توصيل مو مطابق أو نقطة تلامس ضعيفة مرتبطة بـ منظومة الزيت.",
  "ربط أو توصيل غير سليم",
  [C("برغي أو ترمنل مرخي", 35), C("توصيل سابق مو مطابق", 30), C("أكسدة أو تلف بنقطة الربط", 20), C("تحميل أعلى من قدرة المولد", 15)],
  ["اعزل التغذية قبل إعادة الربط.", "نظف أو بدل اللگ أو الترمنل المتضرر."],
  "حرجة",
  "المولدات engine oil loose wrong connection",
],
[
  "generator-035",
  "منظومة الزيت",
  "قراءة أو خرج منظومة الزيت مو طبيعي",
  "قراءة أو خرج منظومة الزيت أعلى أو أقل أو مختلف عن المطلوب.",
  "قراءة أو خرج غير طبيعي",
  [C("إعداد أو معايرة غلط", 35), C("مصدر أو حمل مو طبيعي", 30), C("المكوّن أو الحساس المرتبط بيه متضرر", 20), C("تحميل أعلى من قدرة المولد", 15)],
  ["قارن القراءة بالمواصفات أو بقياس مرجعي.", "راجع الإعدادات والمكوّن المرتبط بالقياس."],
  "متوسطة",
  "المولدات engine oil abnormal reading output",
],
[
  "generator-036",
  "منظومة التبريد",
  "منظومة التبريد ما يشتغل أو ما ينفذ وظيفته",
  "وظيفة منظومة التبريد متوقفة أو مو موجودة بالصورة الطبيعية.",
  "توقف وظيفة منظومة التبريد",
  [C("تغذية أو إشارة مفقودة", 35), C("المكوّن نفسه متضرر", 30), C("توصيل أو حماية مانعة التشغيل", 20), C("تحميل أعلى من قدرة المولد", 15)],
  ["افحص التغذية والحماية والتوصيلات.", "بدل أو صلح الجزء المتضرر بعد العزل."],
  "عالية",
  "المولدات cooling system not working open",
],
[
  "generator-037",
  "منظومة التبريد",
  "حرارة منظومة التبريد ترتفع",
  "حرارة منظومة التبريد أعلى من الطبيعي أثناء التشغيل.",
  "ارتفاع حرارة منظومة التبريد",
  [C("تحميل أعلى من التصميم", 35), C("ربط مقاومته عالية", 30), C("تهوية أو تبريد غير كافي", 20), C("تحميل أعلى من قدرة المولد", 15)],
  ["خفف الحمل إذا ممكن وافحص التبريد.", "اعزل المعدة إذا الحرارة أو ريحة الحرك قوية."],
  "حرجة",
  "المولدات cooling system overheating hot",
],
[
  "generator-038",
  "منظومة التبريد",
  "منظومة التبريد يشتغل أو يقرا بصورة غير مستقرة",
  "أداء أو قراءة منظومة التبريد تتغير أو تقطع بدون سبب طبيعي.",
  "تشغيل أو قراءة متقطعة",
  [C("ترمنل أو وصلة مرخية", 35), C("تغذية أو إشارة متذبذبة", 30), C("المكوّن بدأ يتدهور", 20), C("تحميل أعلى من قدرة المولد", 15)],
  ["راقب الحالة وقت ظهور العطل.", "افحص الربطات والتغذية والإشارة المرتبطة بالمكوّن."],
  "عالية",
  "المولدات cooling system intermittent unstable",
],
[
  "generator-039",
  "منظومة التبريد",
  "منظومة التبريد بيه ربط أو توصيل مو صحيح",
  "أكو ربط مرخي أو توصيل مو مطابق أو نقطة تلامس ضعيفة مرتبطة بـ منظومة التبريد.",
  "ربط أو توصيل غير سليم",
  [C("برغي أو ترمنل مرخي", 35), C("توصيل سابق مو مطابق", 30), C("أكسدة أو تلف بنقطة الربط", 20), C("تحميل أعلى من قدرة المولد", 15)],
  ["اعزل التغذية قبل إعادة الربط.", "نظف أو بدل اللگ أو الترمنل المتضرر."],
  "حرجة",
  "المولدات cooling system loose wrong connection",
],
[
  "generator-040",
  "منظومة التبريد",
  "قراءة أو خرج منظومة التبريد مو طبيعي",
  "قراءة أو خرج منظومة التبريد أعلى أو أقل أو مختلف عن المطلوب.",
  "قراءة أو خرج غير طبيعي",
  [C("إعداد أو معايرة غلط", 35), C("مصدر أو حمل مو طبيعي", 30), C("المكوّن أو الحساس المرتبط بيه متضرر", 20), C("تحميل أعلى من قدرة المولد", 15)],
  ["قارن القراءة بالمواصفات أو بقياس مرجعي.", "راجع الإعدادات والمكوّن المرتبط بالقياس."],
  "متوسطة",
  "المولدات cooling system abnormal reading output",
],
[
  "generator-041",
  "Radiator",
  "Radiator ما يشتغل أو ما ينفذ وظيفته",
  "وظيفة Radiator متوقفة أو مو موجودة بالصورة الطبيعية.",
  "توقف وظيفة Radiator",
  [C("تغذية أو إشارة مفقودة", 35), C("المكوّن نفسه متضرر", 30), C("توصيل أو حماية مانعة التشغيل", 20), C("تحميل أعلى من قدرة المولد", 15)],
  ["افحص التغذية والحماية والتوصيلات.", "بدل أو صلح الجزء المتضرر بعد العزل."],
  "عالية",
  "المولدات radiator not working open",
],
[
  "generator-042",
  "Radiator",
  "حرارة Radiator ترتفع",
  "حرارة Radiator أعلى من الطبيعي أثناء التشغيل.",
  "ارتفاع حرارة Radiator",
  [C("تحميل أعلى من التصميم", 35), C("ربط مقاومته عالية", 30), C("تهوية أو تبريد غير كافي", 20), C("تحميل أعلى من قدرة المولد", 15)],
  ["خفف الحمل إذا ممكن وافحص التبريد.", "اعزل المعدة إذا الحرارة أو ريحة الحرك قوية."],
  "حرجة",
  "المولدات radiator overheating hot",
],
[
  "generator-043",
  "Radiator",
  "Radiator يشتغل أو يقرا بصورة غير مستقرة",
  "أداء أو قراءة Radiator تتغير أو تقطع بدون سبب طبيعي.",
  "تشغيل أو قراءة متقطعة",
  [C("ترمنل أو وصلة مرخية", 35), C("تغذية أو إشارة متذبذبة", 30), C("المكوّن بدأ يتدهور", 20), C("تحميل أعلى من قدرة المولد", 15)],
  ["راقب الحالة وقت ظهور العطل.", "افحص الربطات والتغذية والإشارة المرتبطة بالمكوّن."],
  "عالية",
  "المولدات radiator intermittent unstable",
],
[
  "generator-044",
  "Radiator",
  "Radiator بيه ربط أو توصيل مو صحيح",
  "أكو ربط مرخي أو توصيل مو مطابق أو نقطة تلامس ضعيفة مرتبطة بـ Radiator.",
  "ربط أو توصيل غير سليم",
  [C("برغي أو ترمنل مرخي", 35), C("توصيل سابق مو مطابق", 30), C("أكسدة أو تلف بنقطة الربط", 20), C("تحميل أعلى من قدرة المولد", 15)],
  ["اعزل التغذية قبل إعادة الربط.", "نظف أو بدل اللگ أو الترمنل المتضرر."],
  "حرجة",
  "المولدات radiator loose wrong connection",
],
[
  "generator-045",
  "Radiator",
  "قراءة أو خرج Radiator مو طبيعي",
  "قراءة أو خرج Radiator أعلى أو أقل أو مختلف عن المطلوب.",
  "قراءة أو خرج غير طبيعي",
  [C("إعداد أو معايرة غلط", 35), C("مصدر أو حمل مو طبيعي", 30), C("المكوّن أو الحساس المرتبط بيه متضرر", 20), C("تحميل أعلى من قدرة المولد", 15)],
  ["قارن القراءة بالمواصفات أو بقياس مرجعي.", "راجع الإعدادات والمكوّن المرتبط بالقياس."],
  "متوسطة",
  "المولدات radiator abnormal reading output",
],
[
  "generator-046",
  "مروحة التبريد",
  "مروحة التبريد ما يشتغل أو ما ينفذ وظيفته",
  "وظيفة مروحة التبريد متوقفة أو مو موجودة بالصورة الطبيعية.",
  "توقف وظيفة مروحة التبريد",
  [C("تغذية أو إشارة مفقودة", 35), C("المكوّن نفسه متضرر", 30), C("توصيل أو حماية مانعة التشغيل", 20), C("تحميل أعلى من قدرة المولد", 15)],
  ["افحص التغذية والحماية والتوصيلات.", "بدل أو صلح الجزء المتضرر بعد العزل."],
  "عالية",
  "المولدات cooling fan not working open",
],
[
  "generator-047",
  "مروحة التبريد",
  "حرارة مروحة التبريد ترتفع",
  "حرارة مروحة التبريد أعلى من الطبيعي أثناء التشغيل.",
  "ارتفاع حرارة مروحة التبريد",
  [C("تحميل أعلى من التصميم", 35), C("ربط مقاومته عالية", 30), C("تهوية أو تبريد غير كافي", 20), C("تحميل أعلى من قدرة المولد", 15)],
  ["خفف الحمل إذا ممكن وافحص التبريد.", "اعزل المعدة إذا الحرارة أو ريحة الحرك قوية."],
  "حرجة",
  "المولدات cooling fan overheating hot",
],
[
  "generator-048",
  "مروحة التبريد",
  "مروحة التبريد يشتغل أو يقرا بصورة غير مستقرة",
  "أداء أو قراءة مروحة التبريد تتغير أو تقطع بدون سبب طبيعي.",
  "تشغيل أو قراءة متقطعة",
  [C("ترمنل أو وصلة مرخية", 35), C("تغذية أو إشارة متذبذبة", 30), C("المكوّن بدأ يتدهور", 20), C("تحميل أعلى من قدرة المولد", 15)],
  ["راقب الحالة وقت ظهور العطل.", "افحص الربطات والتغذية والإشارة المرتبطة بالمكوّن."],
  "عالية",
  "المولدات cooling fan intermittent unstable",
],
[
  "generator-049",
  "مروحة التبريد",
  "مروحة التبريد بيه ربط أو توصيل مو صحيح",
  "أكو ربط مرخي أو توصيل مو مطابق أو نقطة تلامس ضعيفة مرتبطة بـ مروحة التبريد.",
  "ربط أو توصيل غير سليم",
  [C("برغي أو ترمنل مرخي", 35), C("توصيل سابق مو مطابق", 30), C("أكسدة أو تلف بنقطة الربط", 20), C("تحميل أعلى من قدرة المولد", 15)],
  ["اعزل التغذية قبل إعادة الربط.", "نظف أو بدل اللگ أو الترمنل المتضرر."],
  "حرجة",
  "المولدات cooling fan loose wrong connection",
],
[
  "generator-050",
  "مروحة التبريد",
  "قراءة أو خرج مروحة التبريد مو طبيعي",
  "قراءة أو خرج مروحة التبريد أعلى أو أقل أو مختلف عن المطلوب.",
  "قراءة أو خرج غير طبيعي",
  [C("إعداد أو معايرة غلط", 35), C("مصدر أو حمل مو طبيعي", 30), C("المكوّن أو الحساس المرتبط بيه متضرر", 20), C("تحميل أعلى من قدرة المولد", 15)],
  ["قارن القراءة بالمواصفات أو بقياس مرجعي.", "راجع الإعدادات والمكوّن المرتبط بالقياس."],
  "متوسطة",
  "المولدات cooling fan abnormal reading output",
],
[
  "generator-051",
  "Alternator",
  "Alternator ما يشتغل أو ما ينفذ وظيفته",
  "وظيفة Alternator متوقفة أو مو موجودة بالصورة الطبيعية.",
  "توقف وظيفة Alternator",
  [C("تغذية أو إشارة مفقودة", 35), C("المكوّن نفسه متضرر", 30), C("توصيل أو حماية مانعة التشغيل", 20), C("تحميل أعلى من قدرة المولد", 15)],
  ["افحص التغذية والحماية والتوصيلات.", "بدل أو صلح الجزء المتضرر بعد العزل."],
  "عالية",
  "المولدات alternator not working open",
],
[
  "generator-052",
  "Alternator",
  "حرارة Alternator ترتفع",
  "حرارة Alternator أعلى من الطبيعي أثناء التشغيل.",
  "ارتفاع حرارة Alternator",
  [C("تحميل أعلى من التصميم", 35), C("ربط مقاومته عالية", 30), C("تهوية أو تبريد غير كافي", 20), C("تحميل أعلى من قدرة المولد", 15)],
  ["خفف الحمل إذا ممكن وافحص التبريد.", "اعزل المعدة إذا الحرارة أو ريحة الحرك قوية."],
  "حرجة",
  "المولدات alternator overheating hot",
],
[
  "generator-053",
  "Alternator",
  "Alternator يشتغل أو يقرا بصورة غير مستقرة",
  "أداء أو قراءة Alternator تتغير أو تقطع بدون سبب طبيعي.",
  "تشغيل أو قراءة متقطعة",
  [C("ترمنل أو وصلة مرخية", 35), C("تغذية أو إشارة متذبذبة", 30), C("المكوّن بدأ يتدهور", 20), C("تحميل أعلى من قدرة المولد", 15)],
  ["راقب الحالة وقت ظهور العطل.", "افحص الربطات والتغذية والإشارة المرتبطة بالمكوّن."],
  "عالية",
  "المولدات alternator intermittent unstable",
],
[
  "generator-054",
  "Alternator",
  "Alternator بيه ربط أو توصيل مو صحيح",
  "أكو ربط مرخي أو توصيل مو مطابق أو نقطة تلامس ضعيفة مرتبطة بـ Alternator.",
  "ربط أو توصيل غير سليم",
  [C("برغي أو ترمنل مرخي", 35), C("توصيل سابق مو مطابق", 30), C("أكسدة أو تلف بنقطة الربط", 20), C("تحميل أعلى من قدرة المولد", 15)],
  ["اعزل التغذية قبل إعادة الربط.", "نظف أو بدل اللگ أو الترمنل المتضرر."],
  "حرجة",
  "المولدات alternator loose wrong connection",
],
[
  "generator-055",
  "Alternator",
  "قراءة أو خرج Alternator مو طبيعي",
  "قراءة أو خرج Alternator أعلى أو أقل أو مختلف عن المطلوب.",
  "قراءة أو خرج غير طبيعي",
  [C("إعداد أو معايرة غلط", 35), C("مصدر أو حمل مو طبيعي", 30), C("المكوّن أو الحساس المرتبط بيه متضرر", 20), C("تحميل أعلى من قدرة المولد", 15)],
  ["قارن القراءة بالمواصفات أو بقياس مرجعي.", "راجع الإعدادات والمكوّن المرتبط بالقياس."],
  "متوسطة",
  "المولدات alternator abnormal reading output",
],
[
  "generator-056",
  "AVR",
  "AVR ما يشتغل أو ما ينفذ وظيفته",
  "وظيفة AVR متوقفة أو مو موجودة بالصورة الطبيعية.",
  "توقف وظيفة AVR",
  [C("تغذية أو إشارة مفقودة", 35), C("المكوّن نفسه متضرر", 30), C("توصيل أو حماية مانعة التشغيل", 20), C("تحميل أعلى من قدرة المولد", 15)],
  ["افحص التغذية والحماية والتوصيلات.", "بدل أو صلح الجزء المتضرر بعد العزل."],
  "عالية",
  "المولدات avr not working open",
],
[
  "generator-057",
  "AVR",
  "حرارة AVR ترتفع",
  "حرارة AVR أعلى من الطبيعي أثناء التشغيل.",
  "ارتفاع حرارة AVR",
  [C("تحميل أعلى من التصميم", 35), C("ربط مقاومته عالية", 30), C("تهوية أو تبريد غير كافي", 20), C("تحميل أعلى من قدرة المولد", 15)],
  ["خفف الحمل إذا ممكن وافحص التبريد.", "اعزل المعدة إذا الحرارة أو ريحة الحرك قوية."],
  "حرجة",
  "المولدات avr overheating hot",
],
[
  "generator-058",
  "AVR",
  "AVR يشتغل أو يقرا بصورة غير مستقرة",
  "أداء أو قراءة AVR تتغير أو تقطع بدون سبب طبيعي.",
  "تشغيل أو قراءة متقطعة",
  [C("ترمنل أو وصلة مرخية", 35), C("تغذية أو إشارة متذبذبة", 30), C("المكوّن بدأ يتدهور", 20), C("تحميل أعلى من قدرة المولد", 15)],
  ["راقب الحالة وقت ظهور العطل.", "افحص الربطات والتغذية والإشارة المرتبطة بالمكوّن."],
  "عالية",
  "المولدات avr intermittent unstable",
],
[
  "generator-059",
  "AVR",
  "AVR بيه ربط أو توصيل مو صحيح",
  "أكو ربط مرخي أو توصيل مو مطابق أو نقطة تلامس ضعيفة مرتبطة بـ AVR.",
  "ربط أو توصيل غير سليم",
  [C("برغي أو ترمنل مرخي", 35), C("توصيل سابق مو مطابق", 30), C("أكسدة أو تلف بنقطة الربط", 20), C("تحميل أعلى من قدرة المولد", 15)],
  ["اعزل التغذية قبل إعادة الربط.", "نظف أو بدل اللگ أو الترمنل المتضرر."],
  "حرجة",
  "المولدات avr loose wrong connection",
],
[
  "generator-060",
  "AVR",
  "قراءة أو خرج AVR مو طبيعي",
  "قراءة أو خرج AVR أعلى أو أقل أو مختلف عن المطلوب.",
  "قراءة أو خرج غير طبيعي",
  [C("إعداد أو معايرة غلط", 35), C("مصدر أو حمل مو طبيعي", 30), C("المكوّن أو الحساس المرتبط بيه متضرر", 20), C("تحميل أعلى من قدرة المولد", 15)],
  ["قارن القراءة بالمواصفات أو بقياس مرجعي.", "راجع الإعدادات والمكوّن المرتبط بالقياس."],
  "متوسطة",
  "المولدات avr abnormal reading output",
],
[
  "generator-061",
  "Exciter",
  "Exciter ما يشتغل أو ما ينفذ وظيفته",
  "وظيفة Exciter متوقفة أو مو موجودة بالصورة الطبيعية.",
  "توقف وظيفة Exciter",
  [C("تغذية أو إشارة مفقودة", 35), C("المكوّن نفسه متضرر", 30), C("توصيل أو حماية مانعة التشغيل", 20), C("تحميل أعلى من قدرة المولد", 15)],
  ["افحص التغذية والحماية والتوصيلات.", "بدل أو صلح الجزء المتضرر بعد العزل."],
  "عالية",
  "المولدات exciter not working open",
],
[
  "generator-062",
  "Exciter",
  "حرارة Exciter ترتفع",
  "حرارة Exciter أعلى من الطبيعي أثناء التشغيل.",
  "ارتفاع حرارة Exciter",
  [C("تحميل أعلى من التصميم", 35), C("ربط مقاومته عالية", 30), C("تهوية أو تبريد غير كافي", 20), C("تحميل أعلى من قدرة المولد", 15)],
  ["خفف الحمل إذا ممكن وافحص التبريد.", "اعزل المعدة إذا الحرارة أو ريحة الحرك قوية."],
  "حرجة",
  "المولدات exciter overheating hot",
],
[
  "generator-063",
  "Exciter",
  "Exciter يشتغل أو يقرا بصورة غير مستقرة",
  "أداء أو قراءة Exciter تتغير أو تقطع بدون سبب طبيعي.",
  "تشغيل أو قراءة متقطعة",
  [C("ترمنل أو وصلة مرخية", 35), C("تغذية أو إشارة متذبذبة", 30), C("المكوّن بدأ يتدهور", 20), C("تحميل أعلى من قدرة المولد", 15)],
  ["راقب الحالة وقت ظهور العطل.", "افحص الربطات والتغذية والإشارة المرتبطة بالمكوّن."],
  "عالية",
  "المولدات exciter intermittent unstable",
],
[
  "generator-064",
  "Exciter",
  "Exciter بيه ربط أو توصيل مو صحيح",
  "أكو ربط مرخي أو توصيل مو مطابق أو نقطة تلامس ضعيفة مرتبطة بـ Exciter.",
  "ربط أو توصيل غير سليم",
  [C("برغي أو ترمنل مرخي", 35), C("توصيل سابق مو مطابق", 30), C("أكسدة أو تلف بنقطة الربط", 20), C("تحميل أعلى من قدرة المولد", 15)],
  ["اعزل التغذية قبل إعادة الربط.", "نظف أو بدل اللگ أو الترمنل المتضرر."],
  "حرجة",
  "المولدات exciter loose wrong connection",
],
[
  "generator-065",
  "Exciter",
  "قراءة أو خرج Exciter مو طبيعي",
  "قراءة أو خرج Exciter أعلى أو أقل أو مختلف عن المطلوب.",
  "قراءة أو خرج غير طبيعي",
  [C("إعداد أو معايرة غلط", 35), C("مصدر أو حمل مو طبيعي", 30), C("المكوّن أو الحساس المرتبط بيه متضرر", 20), C("تحميل أعلى من قدرة المولد", 15)],
  ["قارن القراءة بالمواصفات أو بقياس مرجعي.", "راجع الإعدادات والمكوّن المرتبط بالقياس."],
  "متوسطة",
  "المولدات exciter abnormal reading output",
],
[
  "generator-066",
  "حساس RPM",
  "حساس RPM ما يشتغل أو ما ينفذ وظيفته",
  "وظيفة حساس RPM متوقفة أو مو موجودة بالصورة الطبيعية.",
  "توقف وظيفة حساس RPM",
  [C("تغذية أو إشارة مفقودة", 35), C("المكوّن نفسه متضرر", 30), C("توصيل أو حماية مانعة التشغيل", 20), C("تحميل أعلى من قدرة المولد", 15)],
  ["افحص التغذية والحماية والتوصيلات.", "بدل أو صلح الجزء المتضرر بعد العزل."],
  "عالية",
  "المولدات rpm sensor not working open",
],
[
  "generator-067",
  "حساس RPM",
  "حرارة حساس RPM ترتفع",
  "حرارة حساس RPM أعلى من الطبيعي أثناء التشغيل.",
  "ارتفاع حرارة حساس RPM",
  [C("تحميل أعلى من التصميم", 35), C("ربط مقاومته عالية", 30), C("تهوية أو تبريد غير كافي", 20), C("تحميل أعلى من قدرة المولد", 15)],
  ["خفف الحمل إذا ممكن وافحص التبريد.", "اعزل المعدة إذا الحرارة أو ريحة الحرك قوية."],
  "حرجة",
  "المولدات rpm sensor overheating hot",
],
[
  "generator-068",
  "حساس RPM",
  "حساس RPM يشتغل أو يقرا بصورة غير مستقرة",
  "أداء أو قراءة حساس RPM تتغير أو تقطع بدون سبب طبيعي.",
  "تشغيل أو قراءة متقطعة",
  [C("ترمنل أو وصلة مرخية", 35), C("تغذية أو إشارة متذبذبة", 30), C("المكوّن بدأ يتدهور", 20), C("تحميل أعلى من قدرة المولد", 15)],
  ["راقب الحالة وقت ظهور العطل.", "افحص الربطات والتغذية والإشارة المرتبطة بالمكوّن."],
  "عالية",
  "المولدات rpm sensor intermittent unstable",
],
[
  "generator-069",
  "حساس RPM",
  "حساس RPM بيه ربط أو توصيل مو صحيح",
  "أكو ربط مرخي أو توصيل مو مطابق أو نقطة تلامس ضعيفة مرتبطة بـ حساس RPM.",
  "ربط أو توصيل غير سليم",
  [C("برغي أو ترمنل مرخي", 35), C("توصيل سابق مو مطابق", 30), C("أكسدة أو تلف بنقطة الربط", 20), C("تحميل أعلى من قدرة المولد", 15)],
  ["اعزل التغذية قبل إعادة الربط.", "نظف أو بدل اللگ أو الترمنل المتضرر."],
  "حرجة",
  "المولدات rpm sensor loose wrong connection",
],
[
  "generator-070",
  "حساس RPM",
  "قراءة أو خرج حساس RPM مو طبيعي",
  "قراءة أو خرج حساس RPM أعلى أو أقل أو مختلف عن المطلوب.",
  "قراءة أو خرج غير طبيعي",
  [C("إعداد أو معايرة غلط", 35), C("مصدر أو حمل مو طبيعي", 30), C("المكوّن أو الحساس المرتبط بيه متضرر", 20), C("تحميل أعلى من قدرة المولد", 15)],
  ["قارن القراءة بالمواصفات أو بقياس مرجعي.", "راجع الإعدادات والمكوّن المرتبط بالقياس."],
  "متوسطة",
  "المولدات rpm sensor abnormal reading output",
],
[
  "generator-071",
  "حساس ضغط الزيت",
  "حساس ضغط الزيت ما يشتغل أو ما ينفذ وظيفته",
  "وظيفة حساس ضغط الزيت متوقفة أو مو موجودة بالصورة الطبيعية.",
  "توقف وظيفة حساس ضغط الزيت",
  [C("تغذية أو إشارة مفقودة", 35), C("المكوّن نفسه متضرر", 30), C("توصيل أو حماية مانعة التشغيل", 20), C("تحميل أعلى من قدرة المولد", 15)],
  ["افحص التغذية والحماية والتوصيلات.", "بدل أو صلح الجزء المتضرر بعد العزل."],
  "عالية",
  "المولدات oil pressure sensor not working open",
],
[
  "generator-072",
  "حساس ضغط الزيت",
  "حرارة حساس ضغط الزيت ترتفع",
  "حرارة حساس ضغط الزيت أعلى من الطبيعي أثناء التشغيل.",
  "ارتفاع حرارة حساس ضغط الزيت",
  [C("تحميل أعلى من التصميم", 35), C("ربط مقاومته عالية", 30), C("تهوية أو تبريد غير كافي", 20), C("تحميل أعلى من قدرة المولد", 15)],
  ["خفف الحمل إذا ممكن وافحص التبريد.", "اعزل المعدة إذا الحرارة أو ريحة الحرك قوية."],
  "حرجة",
  "المولدات oil pressure sensor overheating hot",
],
[
  "generator-073",
  "حساس ضغط الزيت",
  "حساس ضغط الزيت يشتغل أو يقرا بصورة غير مستقرة",
  "أداء أو قراءة حساس ضغط الزيت تتغير أو تقطع بدون سبب طبيعي.",
  "تشغيل أو قراءة متقطعة",
  [C("ترمنل أو وصلة مرخية", 35), C("تغذية أو إشارة متذبذبة", 30), C("المكوّن بدأ يتدهور", 20), C("تحميل أعلى من قدرة المولد", 15)],
  ["راقب الحالة وقت ظهور العطل.", "افحص الربطات والتغذية والإشارة المرتبطة بالمكوّن."],
  "عالية",
  "المولدات oil pressure sensor intermittent unstable",
],
[
  "generator-074",
  "حساس ضغط الزيت",
  "حساس ضغط الزيت بيه ربط أو توصيل مو صحيح",
  "أكو ربط مرخي أو توصيل مو مطابق أو نقطة تلامس ضعيفة مرتبطة بـ حساس ضغط الزيت.",
  "ربط أو توصيل غير سليم",
  [C("برغي أو ترمنل مرخي", 35), C("توصيل سابق مو مطابق", 30), C("أكسدة أو تلف بنقطة الربط", 20), C("تحميل أعلى من قدرة المولد", 15)],
  ["اعزل التغذية قبل إعادة الربط.", "نظف أو بدل اللگ أو الترمنل المتضرر."],
  "حرجة",
  "المولدات oil pressure sensor loose wrong connection",
],
[
  "generator-075",
  "حساس ضغط الزيت",
  "قراءة أو خرج حساس ضغط الزيت مو طبيعي",
  "قراءة أو خرج حساس ضغط الزيت أعلى أو أقل أو مختلف عن المطلوب.",
  "قراءة أو خرج غير طبيعي",
  [C("إعداد أو معايرة غلط", 35), C("مصدر أو حمل مو طبيعي", 30), C("المكوّن أو الحساس المرتبط بيه متضرر", 20), C("تحميل أعلى من قدرة المولد", 15)],
  ["قارن القراءة بالمواصفات أو بقياس مرجعي.", "راجع الإعدادات والمكوّن المرتبط بالقياس."],
  "متوسطة",
  "المولدات oil pressure sensor abnormal reading output",
],
[
  "generator-076",
  "حساس الحرارة",
  "حساس الحرارة ما يشتغل أو ما ينفذ وظيفته",
  "وظيفة حساس الحرارة متوقفة أو مو موجودة بالصورة الطبيعية.",
  "توقف وظيفة حساس الحرارة",
  [C("تغذية أو إشارة مفقودة", 35), C("المكوّن نفسه متضرر", 30), C("توصيل أو حماية مانعة التشغيل", 20), C("تحميل أعلى من قدرة المولد", 15)],
  ["افحص التغذية والحماية والتوصيلات.", "بدل أو صلح الجزء المتضرر بعد العزل."],
  "عالية",
  "المولدات temperature sensor not working open",
],
[
  "generator-077",
  "حساس الحرارة",
  "حرارة حساس الحرارة ترتفع",
  "حرارة حساس الحرارة أعلى من الطبيعي أثناء التشغيل.",
  "ارتفاع حرارة حساس الحرارة",
  [C("تحميل أعلى من التصميم", 35), C("ربط مقاومته عالية", 30), C("تهوية أو تبريد غير كافي", 20), C("تحميل أعلى من قدرة المولد", 15)],
  ["خفف الحمل إذا ممكن وافحص التبريد.", "اعزل المعدة إذا الحرارة أو ريحة الحرك قوية."],
  "حرجة",
  "المولدات temperature sensor overheating hot",
],
[
  "generator-078",
  "حساس الحرارة",
  "حساس الحرارة يشتغل أو يقرا بصورة غير مستقرة",
  "أداء أو قراءة حساس الحرارة تتغير أو تقطع بدون سبب طبيعي.",
  "تشغيل أو قراءة متقطعة",
  [C("ترمنل أو وصلة مرخية", 35), C("تغذية أو إشارة متذبذبة", 30), C("المكوّن بدأ يتدهور", 20), C("تحميل أعلى من قدرة المولد", 15)],
  ["راقب الحالة وقت ظهور العطل.", "افحص الربطات والتغذية والإشارة المرتبطة بالمكوّن."],
  "عالية",
  "المولدات temperature sensor intermittent unstable",
],
[
  "generator-079",
  "حساس الحرارة",
  "حساس الحرارة بيه ربط أو توصيل مو صحيح",
  "أكو ربط مرخي أو توصيل مو مطابق أو نقطة تلامس ضعيفة مرتبطة بـ حساس الحرارة.",
  "ربط أو توصيل غير سليم",
  [C("برغي أو ترمنل مرخي", 35), C("توصيل سابق مو مطابق", 30), C("أكسدة أو تلف بنقطة الربط", 20), C("تحميل أعلى من قدرة المولد", 15)],
  ["اعزل التغذية قبل إعادة الربط.", "نظف أو بدل اللگ أو الترمنل المتضرر."],
  "حرجة",
  "المولدات temperature sensor loose wrong connection",
],
[
  "generator-080",
  "حساس الحرارة",
  "قراءة أو خرج حساس الحرارة مو طبيعي",
  "قراءة أو خرج حساس الحرارة أعلى أو أقل أو مختلف عن المطلوب.",
  "قراءة أو خرج غير طبيعي",
  [C("إعداد أو معايرة غلط", 35), C("مصدر أو حمل مو طبيعي", 30), C("المكوّن أو الحساس المرتبط بيه متضرر", 20), C("تحميل أعلى من قدرة المولد", 15)],
  ["قارن القراءة بالمواصفات أو بقياس مرجعي.", "راجع الإعدادات والمكوّن المرتبط بالقياس."],
  "متوسطة",
  "المولدات temperature sensor abnormal reading output",
],
[
  "generator-081",
  "Generator Controller",
  "Generator Controller ما يشتغل أو ما ينفذ وظيفته",
  "وظيفة Generator Controller متوقفة أو مو موجودة بالصورة الطبيعية.",
  "توقف وظيفة Generator Controller",
  [C("تغذية أو إشارة مفقودة", 35), C("المكوّن نفسه متضرر", 30), C("توصيل أو حماية مانعة التشغيل", 20), C("تحميل أعلى من قدرة المولد", 15)],
  ["افحص التغذية والحماية والتوصيلات.", "بدل أو صلح الجزء المتضرر بعد العزل."],
  "عالية",
  "المولدات genset controller not working open",
],
[
  "generator-082",
  "Generator Controller",
  "حرارة Generator Controller ترتفع",
  "حرارة Generator Controller أعلى من الطبيعي أثناء التشغيل.",
  "ارتفاع حرارة Generator Controller",
  [C("تحميل أعلى من التصميم", 35), C("ربط مقاومته عالية", 30), C("تهوية أو تبريد غير كافي", 20), C("تحميل أعلى من قدرة المولد", 15)],
  ["خفف الحمل إذا ممكن وافحص التبريد.", "اعزل المعدة إذا الحرارة أو ريحة الحرك قوية."],
  "حرجة",
  "المولدات genset controller overheating hot",
],
[
  "generator-083",
  "Generator Controller",
  "Generator Controller يشتغل أو يقرا بصورة غير مستقرة",
  "أداء أو قراءة Generator Controller تتغير أو تقطع بدون سبب طبيعي.",
  "تشغيل أو قراءة متقطعة",
  [C("ترمنل أو وصلة مرخية", 35), C("تغذية أو إشارة متذبذبة", 30), C("المكوّن بدأ يتدهور", 20), C("تحميل أعلى من قدرة المولد", 15)],
  ["راقب الحالة وقت ظهور العطل.", "افحص الربطات والتغذية والإشارة المرتبطة بالمكوّن."],
  "عالية",
  "المولدات genset controller intermittent unstable",
],
[
  "generator-084",
  "Generator Controller",
  "Generator Controller بيه ربط أو توصيل مو صحيح",
  "أكو ربط مرخي أو توصيل مو مطابق أو نقطة تلامس ضعيفة مرتبطة بـ Generator Controller.",
  "ربط أو توصيل غير سليم",
  [C("برغي أو ترمنل مرخي", 35), C("توصيل سابق مو مطابق", 30), C("أكسدة أو تلف بنقطة الربط", 20), C("تحميل أعلى من قدرة المولد", 15)],
  ["اعزل التغذية قبل إعادة الربط.", "نظف أو بدل اللگ أو الترمنل المتضرر."],
  "حرجة",
  "المولدات genset controller loose wrong connection",
],
[
  "generator-085",
  "Generator Controller",
  "قراءة أو خرج Generator Controller مو طبيعي",
  "قراءة أو خرج Generator Controller أعلى أو أقل أو مختلف عن المطلوب.",
  "قراءة أو خرج غير طبيعي",
  [C("إعداد أو معايرة غلط", 35), C("مصدر أو حمل مو طبيعي", 30), C("المكوّن أو الحساس المرتبط بيه متضرر", 20), C("تحميل أعلى من قدرة المولد", 15)],
  ["قارن القراءة بالمواصفات أو بقياس مرجعي.", "راجع الإعدادات والمكوّن المرتبط بالقياس."],
  "متوسطة",
  "المولدات genset controller abnormal reading output",
],
[
  "generator-086",
  "قاطع خرج المولد",
  "قاطع خرج المولد ما يشتغل أو ما ينفذ وظيفته",
  "وظيفة قاطع خرج المولد متوقفة أو مو موجودة بالصورة الطبيعية.",
  "توقف وظيفة قاطع خرج المولد",
  [C("تغذية أو إشارة مفقودة", 35), C("المكوّن نفسه متضرر", 30), C("توصيل أو حماية مانعة التشغيل", 20), C("تحميل أعلى من قدرة المولد", 15)],
  ["افحص التغذية والحماية والتوصيلات.", "بدل أو صلح الجزء المتضرر بعد العزل."],
  "عالية",
  "المولدات output breaker not working open",
],
[
  "generator-087",
  "قاطع خرج المولد",
  "حرارة قاطع خرج المولد ترتفع",
  "حرارة قاطع خرج المولد أعلى من الطبيعي أثناء التشغيل.",
  "ارتفاع حرارة قاطع خرج المولد",
  [C("تحميل أعلى من التصميم", 35), C("ربط مقاومته عالية", 30), C("تهوية أو تبريد غير كافي", 20), C("تحميل أعلى من قدرة المولد", 15)],
  ["خفف الحمل إذا ممكن وافحص التبريد.", "اعزل المعدة إذا الحرارة أو ريحة الحرك قوية."],
  "حرجة",
  "المولدات output breaker overheating hot",
],
[
  "generator-088",
  "قاطع خرج المولد",
  "قاطع خرج المولد يشتغل أو يقرا بصورة غير مستقرة",
  "أداء أو قراءة قاطع خرج المولد تتغير أو تقطع بدون سبب طبيعي.",
  "تشغيل أو قراءة متقطعة",
  [C("ترمنل أو وصلة مرخية", 35), C("تغذية أو إشارة متذبذبة", 30), C("المكوّن بدأ يتدهور", 20), C("تحميل أعلى من قدرة المولد", 15)],
  ["راقب الحالة وقت ظهور العطل.", "افحص الربطات والتغذية والإشارة المرتبطة بالمكوّن."],
  "عالية",
  "المولدات output breaker intermittent unstable",
],
[
  "generator-089",
  "قاطع خرج المولد",
  "قاطع خرج المولد بيه ربط أو توصيل مو صحيح",
  "أكو ربط مرخي أو توصيل مو مطابق أو نقطة تلامس ضعيفة مرتبطة بـ قاطع خرج المولد.",
  "ربط أو توصيل غير سليم",
  [C("برغي أو ترمنل مرخي", 35), C("توصيل سابق مو مطابق", 30), C("أكسدة أو تلف بنقطة الربط", 20), C("تحميل أعلى من قدرة المولد", 15)],
  ["اعزل التغذية قبل إعادة الربط.", "نظف أو بدل اللگ أو الترمنل المتضرر."],
  "حرجة",
  "المولدات output breaker loose wrong connection",
],
[
  "generator-090",
  "قاطع خرج المولد",
  "قراءة أو خرج قاطع خرج المولد مو طبيعي",
  "قراءة أو خرج قاطع خرج المولد أعلى أو أقل أو مختلف عن المطلوب.",
  "قراءة أو خرج غير طبيعي",
  [C("إعداد أو معايرة غلط", 35), C("مصدر أو حمل مو طبيعي", 30), C("المكوّن أو الحساس المرتبط بيه متضرر", 20), C("تحميل أعلى من قدرة المولد", 15)],
  ["قارن القراءة بالمواصفات أو بقياس مرجعي.", "راجع الإعدادات والمكوّن المرتبط بالقياس."],
  "متوسطة",
  "المولدات output breaker abnormal reading output",
],
[
  "generator-091",
  "كيبلات خرج المولد",
  "كيبلات خرج المولد ما يشتغل أو ما ينفذ وظيفته",
  "وظيفة كيبلات خرج المولد متوقفة أو مو موجودة بالصورة الطبيعية.",
  "توقف وظيفة كيبلات خرج المولد",
  [C("تغذية أو إشارة مفقودة", 35), C("المكوّن نفسه متضرر", 30), C("توصيل أو حماية مانعة التشغيل", 20), C("تحميل أعلى من قدرة المولد", 15)],
  ["افحص التغذية والحماية والتوصيلات.", "بدل أو صلح الجزء المتضرر بعد العزل."],
  "عالية",
  "المولدات output cable not working open",
],
[
  "generator-092",
  "كيبلات خرج المولد",
  "حرارة كيبلات خرج المولد ترتفع",
  "حرارة كيبلات خرج المولد أعلى من الطبيعي أثناء التشغيل.",
  "ارتفاع حرارة كيبلات خرج المولد",
  [C("تحميل أعلى من التصميم", 35), C("ربط مقاومته عالية", 30), C("تهوية أو تبريد غير كافي", 20), C("تحميل أعلى من قدرة المولد", 15)],
  ["خفف الحمل إذا ممكن وافحص التبريد.", "اعزل المعدة إذا الحرارة أو ريحة الحرك قوية."],
  "حرجة",
  "المولدات output cable overheating hot",
],
[
  "generator-093",
  "كيبلات خرج المولد",
  "كيبلات خرج المولد يشتغل أو يقرا بصورة غير مستقرة",
  "أداء أو قراءة كيبلات خرج المولد تتغير أو تقطع بدون سبب طبيعي.",
  "تشغيل أو قراءة متقطعة",
  [C("ترمنل أو وصلة مرخية", 35), C("تغذية أو إشارة متذبذبة", 30), C("المكوّن بدأ يتدهور", 20), C("تحميل أعلى من قدرة المولد", 15)],
  ["راقب الحالة وقت ظهور العطل.", "افحص الربطات والتغذية والإشارة المرتبطة بالمكوّن."],
  "عالية",
  "المولدات output cable intermittent unstable",
],
[
  "generator-094",
  "كيبلات خرج المولد",
  "كيبلات خرج المولد بيه ربط أو توصيل مو صحيح",
  "أكو ربط مرخي أو توصيل مو مطابق أو نقطة تلامس ضعيفة مرتبطة بـ كيبلات خرج المولد.",
  "ربط أو توصيل غير سليم",
  [C("برغي أو ترمنل مرخي", 35), C("توصيل سابق مو مطابق", 30), C("أكسدة أو تلف بنقطة الربط", 20), C("تحميل أعلى من قدرة المولد", 15)],
  ["اعزل التغذية قبل إعادة الربط.", "نظف أو بدل اللگ أو الترمنل المتضرر."],
  "حرجة",
  "المولدات output cable loose wrong connection",
],
[
  "generator-095",
  "كيبلات خرج المولد",
  "قراءة أو خرج كيبلات خرج المولد مو طبيعي",
  "قراءة أو خرج كيبلات خرج المولد أعلى أو أقل أو مختلف عن المطلوب.",
  "قراءة أو خرج غير طبيعي",
  [C("إعداد أو معايرة غلط", 35), C("مصدر أو حمل مو طبيعي", 30), C("المكوّن أو الحساس المرتبط بيه متضرر", 20), C("تحميل أعلى من قدرة المولد", 15)],
  ["قارن القراءة بالمواصفات أو بقياس مرجعي.", "راجع الإعدادات والمكوّن المرتبط بالقياس."],
  "متوسطة",
  "المولدات output cable abnormal reading output",
],
[
  "generator-096",
  "تأريض المولد",
  "تأريض المولد ما يشتغل أو ما ينفذ وظيفته",
  "وظيفة تأريض المولد متوقفة أو مو موجودة بالصورة الطبيعية.",
  "توقف وظيفة تأريض المولد",
  [C("تغذية أو إشارة مفقودة", 35), C("المكوّن نفسه متضرر", 30), C("توصيل أو حماية مانعة التشغيل", 20), C("تحميل أعلى من قدرة المولد", 15)],
  ["افحص التغذية والحماية والتوصيلات.", "بدل أو صلح الجزء المتضرر بعد العزل."],
  "عالية",
  "المولدات generator earthing not working open",
],
[
  "generator-097",
  "تأريض المولد",
  "حرارة تأريض المولد ترتفع",
  "حرارة تأريض المولد أعلى من الطبيعي أثناء التشغيل.",
  "ارتفاع حرارة تأريض المولد",
  [C("تحميل أعلى من التصميم", 35), C("ربط مقاومته عالية", 30), C("تهوية أو تبريد غير كافي", 20), C("تحميل أعلى من قدرة المولد", 15)],
  ["خفف الحمل إذا ممكن وافحص التبريد.", "اعزل المعدة إذا الحرارة أو ريحة الحرك قوية."],
  "حرجة",
  "المولدات generator earthing overheating hot",
],
[
  "generator-098",
  "تأريض المولد",
  "تأريض المولد يشتغل أو يقرا بصورة غير مستقرة",
  "أداء أو قراءة تأريض المولد تتغير أو تقطع بدون سبب طبيعي.",
  "تشغيل أو قراءة متقطعة",
  [C("ترمنل أو وصلة مرخية", 35), C("تغذية أو إشارة متذبذبة", 30), C("المكوّن بدأ يتدهور", 20), C("تحميل أعلى من قدرة المولد", 15)],
  ["راقب الحالة وقت ظهور العطل.", "افحص الربطات والتغذية والإشارة المرتبطة بالمكوّن."],
  "عالية",
  "المولدات generator earthing intermittent unstable",
],
[
  "generator-099",
  "تأريض المولد",
  "تأريض المولد بيه ربط أو توصيل مو صحيح",
  "أكو ربط مرخي أو توصيل مو مطابق أو نقطة تلامس ضعيفة مرتبطة بـ تأريض المولد.",
  "ربط أو توصيل غير سليم",
  [C("برغي أو ترمنل مرخي", 35), C("توصيل سابق مو مطابق", 30), C("أكسدة أو تلف بنقطة الربط", 20), C("تحميل أعلى من قدرة المولد", 15)],
  ["اعزل التغذية قبل إعادة الربط.", "نظف أو بدل اللگ أو الترمنل المتضرر."],
  "حرجة",
  "المولدات generator earthing loose wrong connection",
],
[
  "generator-100",
  "تأريض المولد",
  "قراءة أو خرج تأريض المولد مو طبيعي",
  "قراءة أو خرج تأريض المولد أعلى أو أقل أو مختلف عن المطلوب.",
  "قراءة أو خرج غير طبيعي",
  [C("إعداد أو معايرة غلط", 35), C("مصدر أو حمل مو طبيعي", 30), C("المكوّن أو الحساس المرتبط بيه متضرر", 20), C("تحميل أعلى من قدرة المولد", 15)],
  ["قارن القراءة بالمواصفات أو بقياس مرجعي.", "راجع الإعدادات والمكوّن المرتبط بالقياس."],
  "متوسطة",
  "المولدات generator earthing abnormal reading output",
],
];

export const generatorFaults: GeneratorFault[] = rows.map(
  ([
    id,
    device_ar,
    name_ar,
    description_ar,
    symptom,
    causes,
    solutions,
    severity,
    keywords,
  ]) => {
    const critical = severity === "حرجة";

    return {
      id,
      category_id: null,
      device_ar,
      name_ar,
      description_ar,
      symptoms: [symptom],
      causes,
      tests: [
        {
          test: "الفحص الأولي",
          location: device_ar,
          method: "أوقف المولد واعزل البطارية والشاحن وATS قبل الصيانة. انتبه من التشغيل الأوتوماتيكي والأجزاء الدوارة والساخنة، والقياسات الحية خليها لفني مولدات مؤهل.",
          normal:
            "القراءات والحرارة والتوصيلات ضمن الطبيعي، وماكو حرك أو تسريب أو تقطيع أو تلف واضح.",
          faulty:
            "حرارة عالية أو فصل متكرر أو ربط مرخي أو قراءة غير طبيعية يدل على عطل يحتاج فحص قبل التشغيل.",
        },
      ],
      solutions,
      severity,
      safety_warnings: critical
        ? [
            "تنبيه: اعزل كل مصادر الطاقة قبل الصيانة وانتبه من التغذية الراجعة أو التشغيل الأوتوماتيكي.",
            "العمل أو القياس على أجزاء حية أو جهد عالي خليه لفني مؤهل وبمعدات مناسبة.",
          ]
        : [
            "افصل وعزل التغذية قبل الفك أو إعادة الربط.",
            "إذا شفت شرر أو ذوبان أو ريحة حرك أو تشغيل غير متوقع، وقف المعدة وخلي فني يفحصها.",
          ],
      error_code: null,
      keywords,
      next_question_key: null,
    };
  },
);
